import { BaseRepository } from "@/repositories/base-repository"
import { type IPurchaseSurchargePeriod } from "@/interfaces/api/purchase-surcharge-period.interface"

export class PurchaseSurchargePeriodRepository extends BaseRepository<IPurchaseSurchargePeriod> {
  protected resourcePath = "administration/purchase-surcharge-periods"
}
